import CopyToClipboard from "components/components/CopyToClipboard/CopyToClipboard";
import React from "react";

import {
  ClientDetailsContainer,
  ClientDetailsRow,
  Label,
  Value,
} from "./style";

type Props = {
  applicationId: string;
  serviceBusNamespace: string;
};

type PairProps = {
  label: string;
  value: string;
};

const LabelValuePairWithCopyButton: React.FC<PairProps> = ({
  label,
  value,
}) => (
  <ClientDetailsRow>
    <Label>{label}</Label>
    <Value>{value}</Value>
    <CopyToClipboard value={value} label={label} />
  </ClientDetailsRow>
);

const ClientDetails: React.FC<Props> = ({
  applicationId,
  serviceBusNamespace,
}) => (
  <ClientDetailsContainer>
    <LabelValuePairWithCopyButton label="Client ID" value={applicationId} />
    <LabelValuePairWithCopyButton
      label="Service Bus namespace"
      value={serviceBusNamespace}
    />
    <LabelValuePairWithCopyButton
      label="Tenant ID"
      value={process.env.REACT_APP_AUTH_TENANT_ID!}
    />
  </ClientDetailsContainer>
);

export default ClientDetails;
